import React from 'react';
import featureUpsellStore from 'subscriptions/featureUpsellStore';

import { BackendEnums } from 'api/codegen';
import toast from 'helpers/toast';

type FeatureRequiredResponse = {
  code: 'feature_required';
  feature: BackendEnums.FeaturesEnum;
};

export function handleFeatureRequired(responseBody: FeatureRequiredResponse) {
  featureUpsellStore.open(responseBody.feature);
}

// common_store lives in localStorage, so the UI can honestly believe in a right the backend has
// already revoked. The backend 403 is the source of truth; this refresh makes the UI catch up.
let refreshPermissions: (() => void) | null = null;

export function registerPermissionsRefresh(refresh: () => void) {
  refreshPermissions = refresh;
}

export function handlePermissionDenied(detail?: string) {
  // A refusal about one object knows why - "the team's replies are a setting" says more than the
  // general line, which is all the gate in front of a whole endpoint can say.
  toast.error(detail || gettext("Your role doesn't have the right to do this. Ask your account admins for access."));
  refreshPermissions?.();
}

type ProtectedErrorResponse = {
  code: 'protected_error';
  message: string;
  usages: {
    name: string;
    url: string;
  }[];
};

export function handleProtectedError(responseBody: ProtectedErrorResponse) {
  toast.error(
    <div className="space-y-2">
      <div>{responseBody.message}</div>
      <div>
        {responseBody.usages.map((usage, i) =>
          usage.url ? (
            <a key={i} href={usage.url} className="text-sm font-medium text-indigo-600 hover:text-indigo-800">
              {usage.name}
            </a>
          ) : (
            <p key={i} className="text-sm font-medium text-indigo-600">
              {usage.name}
            </p>
          ),
        )}
      </div>
    </div>,
  );
}
